import ColumnBreak from './column-break';

export default ColumnBreak;
